export class CustomerDetailsModel {
    id: string;
    userId: string;
    firstname: string;
    lastname: string;
    dob: string;
    contactNo: number;
    email: string;
    ipAddress :string;
    crid?:string;
    username: string;
    password: string;
    photoUrl: string;
    shopName: string;
    businessLicenceNo: string;
    panCard: string;
    registrationDate: string;
    registrationCountry: string;
    jurisdiction: string;
    comment: string;
    businessEmail: string;
    gstTrn: string;
    companyLogo?: any;
    slogan: string;
    addressLine1: string;
    addressLine2:any;
    countryId?: any;
    country: string;
    stateId?: any;
    state: string;
    districtId?: any;
    district: string;
    taluka: string;
    pinCode: string;
    bankAccountNumber: string;
    branchName: string;
    bankName: string;
    accountHolderName: string;
    ifscCode: string;
    referBy: string;
    currentPlanModel: CurrentPlanModel
    playStoreLink?:any;
    appStoreLink?:any;
    installedBy: number|null;
    installedFrom?:any;
    amount: any|number|null;
    taxInPercent: any|number|null;
    totalAmount: any|number|null;
  }
  export class CurrentPlanModel {
    planValidity: number
    planName: string
    planMemberShip: any
    renewalOn: string
    renewalAmount: number
    planId: string
    expiresOn: string
  }